import React, { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config';

const getAdminToken = () => localStorage.getItem('adminKey') || '';

const GAMES = [
  { key: 'battleship', label: 'Portfolio Warfare (Battleship)' },
  { key: 'briefcase', label: 'A Brief Case / Jeopardy' },
  { key: 'golf', label: 'Dead Cat Bounce (Golf)' }
];

const AdminTeams = () => {
  const [selectedGame, setSelectedGame] = useState('battleship');
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const fetchTeams = async (game) => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/teams/${game}`, {
        headers: { 'x-admin-token': getAdminToken() }
      });
      const data = await res.json();
      if (data.success) {
        setTeams(data.teams);
      }
    } catch (err) {
      console.error('Failed to fetch teams:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTeams(selectedGame);
  }, [selectedGame]);

  const handleBackfill = async () => {
    setMessage('Backfilling...');
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/teams/backfill`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-token': getAdminToken() }
      });
      const data = await res.json();
      setMessage(data.message || 'Done');
      fetchTeams(selectedGame);
    } catch (err) {
      setMessage('Backfill failed');
    }
  };

  const handleShuffle = async () => {
    if (!window.confirm(`Shuffle ALL teams for ${selectedGame}? This cannot be undone.`)) return;
    setMessage('Shuffling...');
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/teams/shuffle`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-token': getAdminToken() },
        body: JSON.stringify({ game: selectedGame })
      });
      const data = await res.json();
      setMessage(data.message || 'Done');
      fetchTeams(selectedGame);
    } catch (err) {
      setMessage('Shuffle failed');
    }
  };

  const handleReassign = async (userId, newTeam) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/teams/assign`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-admin-token': getAdminToken() },
        body: JSON.stringify({ userId, game: selectedGame, team: newTeam })
      });
      const data = await res.json();
      if (data.success) {
        fetchTeams(selectedGame);
      }
    } catch (err) {
      console.error('Reassign failed:', err);
    }
  };

  const totalMembers = teams.reduce((sum, t) => sum + t.members.length, 0);

  return (
    <div style={{ padding: '10px' }}>
      <h2>Team Assignments</h2>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', flexWrap: 'wrap' }}>
        {GAMES.map(g => (
          <button
            key={g.key}
            onClick={() => setSelectedGame(g.key)}
            style={{
              padding: '8px 16px',
              background: selectedGame === g.key ? '#4fc3f7' : '#2a2a4e',
              color: selectedGame === g.key ? '#000' : '#ccc',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px'
            }}
          >
            {g.label}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: '8px', marginBottom: '15px', alignItems: 'center' }}>
        <button onClick={handleBackfill} style={btnStyle}>Backfill Unassigned</button>
        <button onClick={handleShuffle} style={{ ...btnStyle, background: '#cc4444' }}>Shuffle All</button>
        <span style={{ color: '#888', fontSize: '13px', marginLeft: '10px' }}>
          {totalMembers} player{totalMembers !== 1 ? 's' : ''} assigned
        </span>
      </div>

      {message && (
        <div style={{ padding: '8px 12px', background: '#1a3a1a', border: '1px solid #44cc44', borderRadius: '4px', marginBottom: '15px', color: '#44cc44', fontSize: '13px' }}>
          {message}
        </div>
      )}

      {loading ? (
        <div style={{ color: '#888' }}>Loading...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '12px' }}>
          {teams.map(team => (
            <div
              key={team.team}
              style={{
                background: '#1a1a2e',
                border: `1px solid ${team.color}40`,
                borderRadius: '8px',
                padding: '12px',
                borderTop: `3px solid ${team.color}`
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                <span style={{ color: team.color, fontWeight: 'bold', fontSize: '15px' }}>
                  {team.name}
                </span>
                <span style={{ color: '#888', fontSize: '12px' }}>
                  {team.members.length} member{team.members.length !== 1 ? 's' : ''}
                </span>
              </div>
              {team.members.length === 0 ? (
                <div style={{ color: '#555', fontSize: '12px', fontStyle: 'italic' }}>No members</div>
              ) : (
                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                  {team.members.map(m => (
                    <div key={m.userId} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '3px 0', borderBottom: '1px solid #222' }}>
                      <span style={{ color: '#ccc', fontSize: '13px' }}>{m.username || m.shortId}</span>
                      <select
                        value={team.team}
                        onChange={(e) => handleReassign(m.userId, parseInt(e.target.value))}
                        style={{ background: '#2a2a4e', color: '#ccc', border: '1px solid #444', borderRadius: '3px', fontSize: '11px', padding: '2px' }}
                      >
                        {teams.map(t => (
                          <option key={t.team} value={t.team}>{t.name}</option>
                        ))}
                      </select>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const btnStyle = {
  padding: '8px 16px',
  background: '#2a6a2a',
  color: '#fff',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '13px'
};

export default AdminTeams;
